<div class="container">


  <app-section-heading [label]="'Általános információk'"></app-section-heading>

  <div class="editor-container">
    <app-html-editor-wrapper [showButtons]="isLoggedIn" *ngIf="content" (contentSaved)="onContentSaved($event)"
                             [value]="content"></app-html-editor-wrapper>
  </div>
</div>
